import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '../../assets/images/logo.png';
const _hoisted_1 = {
  class: "footer"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "flex fy-c fx-c"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "default",
  src: _imports_0
})], -1);
import { useStore } from 'vuex';
import { computed } from 'vue';
// import router from '@/router'

import home from '@/assets/data/home';
export default {
  __name: 'FooterView',
  setup(__props) {
    const {
      footer
    } = home;

    // import { footerList, iconsLink } from '@/assets/data/footerList'

    const store = useStore();
    const global = store.state.bk.global;
    let isMobile = computed(() => global.isMobile);

    // const toView = (obj) => {
    //   router.push(obj.path)
    //   scrollTo(0, 0)
    // }

    return (_ctx, _cache) => {
      const _component_el_image = _resolveComponent("el-image");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_image, {
        class: "w100",
        src: _unref(isMobile) ? _unref(footer).h5 : _unref(footer).pc,
        fit: "contain"
      }, {
        placeholder: _withCtx(() => [_hoisted_2]),
        _: 1
      }, 8, ["src"])]);
    };
  }
};